import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../shared/LoadingSpinner';
import useAuthRole from '../../hooks/useAuthRole';
import { isAdminRole, isFinanceRole, normalizeRole } from '../../constants/membership';

const RoleGuard = ({ role, roles, adminAccess, financeAccess, children }) => {
  const location = useLocation();
  const { user, role: userRole, loading } = useAuthRole();
  const requiredRoles = roles || (role ? [role] : []);

  if (loading) {
    return <LoadingSpinner message="Checking permissions..." />;
  }

  if (!user) {
    return <Navigate to="/member/login" state={{ from: location }} replace />;
  }

  if (adminAccess && !isAdminRole(userRole)) {
    return <Navigate to="/member/dashboard" replace />;
  }

  if (financeAccess && !isFinanceRole(userRole)) {
    return <Navigate to="/member/dashboard" replace />;
  }

  if (requiredRoles.length > 0) {
    const userNorm = normalizeRole(userRole);
    const allowed = requiredRoles.some((r) => normalizeRole(r) === userNorm);
    if (!allowed) {
      return <Navigate to="/member/dashboard" replace />;
    }
  }

  return children;
};

export default RoleGuard;
